import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const AngleRightB = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 11.3L9.9 5.6C9.5 5.2 8.9 5.2 8.5 5.6C8.1 6 8.1 6.6 8.5 7L13.4 11.9L8.5 16.8C8.3 17 8.2 17.2 8.2 17.5C8.2 18.1 8.6 18.5 9.2 18.5C9.5 18.5 9.7 18.4 9.9 18.2L15.6 12.5C15.9 12.3 15.9 11.7 15.5 11.3Z"
      fill="currentColor"
    />
  </svg>
)

export default AngleRightB
